import Image from "../images/Image"

interface StatsCardProps {
  icon: string
  label: string
  value: string | number
  loading?: boolean
  className?: string
}

export function StatsCard({
  icon: Icon,
  label,
  value,
  loading = false,
  className = "",
}: StatsCardProps) {
  return (
    <div
      className={`bg-white rounded-2xl border border-outline 
        p-4 mx-6 gap-3                 /* default comfy */
        lg:p-2 lg:mx-3 lg:gap-2        /* shrink only at lg (1024–1279px) */
        xl:p-4 xl:mx-6 xl:gap-3        /* restore at xl (1280px+) */
        flex flex-wrap sm:flex-nowrap items-start 
        shadow-[0px_4px_4px_0px_#0000000A] 
        ${className}`}
    >
      <div className="flex-shrink-0 relative">
        {loading ? (
          <div className="w-8 h-8 mt-1 bg-gray-200 rounded animate-pulse p-6" />
        ) : (
          <>
            <Image src={Icon} className="mt-1" />
            <div className="absolute inset-0" title={label}></div>
          </>
        )}
      </div>

      <div className="flex flex-col min-w-0 flex-1">
        {loading ? (
          <>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-[150px] mb-1" />
            <div className="h-6 bg-gray-200 rounded animate-pulse w-[20px] ml-1" />
          </>
        ) : (
          <>
            <span className="text-body2 text-primary_text truncate lg:text-sm xl:text-body2">
              {label}
            </span>
            <span className="text-heading4-semi text-primary_text ml-1 break-words lg:text-base xl:text-heading4-semi">
              {value}
            </span>
          </>
        )}
      </div>
    </div>
  )
}